<div class="chat-popup" [class.expanded]="isExpanded" [class.split-view]="showMissionDetails" style="height: 60%;">
  <!-- Main Chat Section -->
  <div class="chat-main-section" [class.with-details]="showMissionDetails">
  <div class="chat-header">
    <div class="header-content">
      <button class="back-btn" *ngIf="view === 'chat' && conversations.length > 1" (click)="backToList()">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
          style="width: 24px; height: 24px; color: white;">
          <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <h3>{{ view === 'list' ? 'Conversations' : (selectedConversation?.candidatName || 'Messagerie') }}</h3>
    </div>
    <div class="header-actions">
      <button class="action-btn" (click)="toggleExpand()" [title]="isExpanded ? 'Réduire' : 'Agrandir'">
        <svg *ngIf="!isExpanded" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <svg *ngIf="isExpanded" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 14h6v6M20 10h-6V4M10 14l-6 6M14 10l6-6" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <!-- <button class="action-btn disabled" title="Ouvrir dans une nouvelle page (Bientôt disponible)">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg> 
      </button>-->
      <button class="close-btn" (click)="closeChat.emit()">
        <svg-icon src="assets/icons/w_close.svg"></svg-icon>
      </button>
    </div>
  </div>

  <!-- Conversation List View -->
  <div class="chat-body list-view" *ngIf="view === 'list'">
    <!-- Search filter -->
    <div class="search-filter" *ngIf="conversations.length > 0">
      <input type="text" [(ngModel)]="searchFilter" (input)="onSearchChange()" placeholder="Rechercher par nom..." class="search-input">
      <svg *ngIf="searchFilter" (click)="clearSearch()" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="clear-icon">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="conversations-list" *ngIf="filteredConversations.length > 0">
      <div *ngFor="let conv of filteredConversations" class="conversation-item" (click)="selectConversation(conv)">
        <div class="conv-avatar">
          <mat-icon>person</mat-icon>
        </div>
        <div class="conv-info">
          <div class="conv-name">{{ conv.candidatName }}</div>
          <div class="conv-last-msg">{{ conv.lastMessage?.message || 'Aucun message' }}</div>
        </div>
        <div class="conv-meta">
          <div class="conv-time" *ngIf="conv.lastMessage">{{ conv.lastMessage.timestamp | date:'shortTime' }}</div>
          <div class="conv-badge" *ngIf="conv.unreadCount > 0">{{ conv.unreadCount }}</div>
        </div>
      </div>
    </div>
    <div class="no-conversations" *ngIf="filteredConversations.length === 0 && conversations.length > 0">
      <p>Aucune conversation trouvée</p>
    </div>
    <div class="no-conversations" *ngIf="conversations.length === 0">
      <p>Aucune conversation</p>
    </div>
  </div>

  <!-- Chat View -->
  <div class="chat-body chat-view" *ngIf="view === 'chat'" #messageContainer>
    <div class="messages-list" *ngIf="messages.length > 0">
      <div *ngFor="let message of messages" class="message-wrapper"
        [ngClass]="{'my-message': isMyMessage(message), 'their-message': !isMyMessage(message)}">
        <div class="message-bubble">
          <!-- <div class="message-sender" *ngIf="!isMyMessage(message)">
            {{ 'Candidat' }}
          </div> -->

          <!-- Mission Reference Badge -->
          <div class="mission-reference-badge" *ngIf="message.missionRef" (click)="openMissionDetails(message)" role="button" tabindex="0" matTooltip="Cliquez pour voir les détails" matTooltipPosition="above">
            <mat-icon class="mission-icon">assignment</mat-icon>
            <span class="mission-text">{{ message.missionRef }}</span>
          </div>

          <!-- Text message -->
          <div class="message-text" *ngIf="!message.attachmentType || message.attachmentType === 'TEXT'">
            {{ message.message }}
          </div>

          <!-- Action button is intentionally NOT rendered on the agency side: the sign URL
               is the candidate's embedded signing session, and opening it from here would
               either silently invalidate the candidate's session or fire a sign event for
               the wrong actor. Only the candidate (interim) app shows the button. 
          <div *ngIf="message.actionUrl" class="message-action-sent">
            <mat-icon class="action-icon">link</mat-icon>
            <span>{{ message.actionLabel || 'Lien' }} envoyé au candidat</span>
          </div> -->

          <!-- Image attachment -->
          <div class="message-attachment image-attachment" *ngIf="message.attachmentType === 'IMAGE'">
            <a [href]="getAttachmentUrl(message)" target="_blank">
              <img [src]="getAttachmentUrl(message)" [alt]="message.attachmentFileName">
            </a>
          </div>

          <!-- PDF attachment -->
          <div class="message-attachment pdf-attachment" *ngIf="message.attachmentType === 'PDF'">
            <a [href]="getAttachmentUrl(message)" target="_blank" class="pdf-link">
              <svg class="pdf-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span class="pdf-name">{{ message.attachmentFileName }}</span>
            </a>
          </div>

          <!-- Voice message -->
          <div class="message-attachment voice-attachment" *ngIf="message.attachmentType === 'VOICE'">
            <div class="voice-player">
              <button class="voice-play-btn" (click)="toggleVoicePlay(message)">
                <svg *ngIf="!message.isPlaying" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
                <svg *ngIf="message.isPlaying" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                </svg>
              </button>
              <div class="voice-waveform">
                <div class="wave-bar" *ngFor="let bar of [1,2,3,4,5,6,7,8,9,10]" [class.active]="message.isPlaying">
                </div>
              </div>
              <audio #audioPlayer [src]="getAttachmentUrl(message)" (ended)="onVoiceEnded(message)"
                style="display: none;"></audio>
            </div>
          </div>

          <!-- Video attachment -->
          <div class="message-attachment video-attachment" *ngIf="message.attachmentType === 'VIDEO'">
            <div class="video-container">
              <video controls width="280" height="180" [poster]="getAttachmentUrl(message)">
                <source [src]="getAttachmentUrl(message)" type="video/mp4">
                Votre navigateur ne supporte pas les vidéos HTML5
              </video>
            </div>
          </div>

          <div class="message-time">
            {{ message.timestamp | date:'short' }}
          </div>
        </div>
      </div>
    </div>
    <div class="no-messages" *ngIf="messages.length === 0">
      <p class="greeting">Envoyer un message au candidat</p>
    </div>
  </div>

  <div class="chat-footer read-only-footer" *ngIf="view === 'chat' && !canContact">
    Consultation seule : votre rôle ne permet pas d'écrire aux candidats.
  </div>

  <div class="chat-footer" *ngIf="view === 'chat' && canContact">
    <!-- Recording indicator -->
    <div class="recording-indicator" *ngIf="isRecording">
      <div class="recording-pulse"></div>
      <span class="recording-text">Enregistrement en cours...</span>
      <span class="recording-time">{{ recordingDuration }}s</span>
    </div>

    <div class="message-input-container" [class.recording-mode]="isRecording">
      <input type="file" #fileInput (change)="onFileSelected($event)"
        accept="image/png,image/jpeg,image/jpg,application/pdf,video/mp4,video/webm,video/ogg" style="display: none;">

      <button class="action-btn attachment-btn" (click)="triggerFileInput()"
        [title]="'Joindre un fichier — images, PDF, vidéo (max ' + maxFileSizeMo + ' Mo)'"
        *ngIf="!isRecording && !newMessage.trim()">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <button class="action-btn voice-btn" (click)="isRecording ? stopRecording() : startRecording()"
        [class.recording]="isRecording"
        [title]="isRecording ? 'Arrêter l\'enregistrement' : 'Enregistrer un message vocal'" *ngIf="!newMessage.trim()">
        <svg *ngIf="!isRecording" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" fill="currentColor" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <svg *ngIf="isRecording" viewBox="0 0 24 24" fill="currentColor">
          <rect x="6" y="6" width="12" height="12" rx="2" />
        </svg>
      </button>

      <textarea #textareaInput *ngIf="!isRecording" [(ngModel)]="newMessage" (keypress)="onKeyPress($event)"
        (input)="autoExpandTextarea()" placeholder="Tapez votre message..." class="message-input" rows="1"></textarea>

      <button class="send-button" (click)="sendMessage()" [disabled]="!newMessage.trim()" *ngIf="!isRecording">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
  </div>

  <!-- Mission Details Section -->
  <div class="mission-details-section" *ngIf="showMissionDetails && selectedMissionData">
    <div class="mission-details-wrapper">
      <div class="mission-header">
        <h3>{{ selectedMissionData.titre }}</h3>
        <button class="close-details-btn" (click)="closeMissionDetails()" title="Fermer les détails">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <div class="mission-content">
        <app-mission-details-1 
          [missionId]="selectedMissionData.id"
          [isEmbedded]="true"
          [hideActionButtons]="true">
        </app-mission-details-1>
      </div>
    </div>
  </div>
</div>